/**
 * Controller for the satisfaction forms statistics page.
 * Initializes DataTable for entities table and Select2 for filters.
 * Charts are rendered using CSS-only (no ApexCharts dependency).
 */
export default class BackofficeSatisfactionFormsStats {
  constructor() {
    this.$container = $('#nps-stats-container');

    if (this.$container.length === 0) {
      return;
    }

    this.initTopEntitiesTable();
    this.initFieldBreakdownTable();
    this.initFilters();
  }

  /**
   * Initialize Select2 for entity filter and template filter
   */
  initFilters() {
    // Entity filter
    $('#entity_id').select2({
      placeholder: 'Sélectionner une entreprise',
      allowClear: true,
      width: '100%'
    });

    // Template filter
    $('#template_id').select2({
      placeholder: 'Sélectionner un modèle',
      allowClear: true,
      width: '100%'
    });
  }

  /**
   * Initialize DataTable for the top entities table
   */
  initTopEntitiesTable() {
    const table = $('#top-entities-table');
    if (table.length === 0) {
      return;
    }

    this.entitiesDataTable = table.DataTable({
      paging: true,
      ordering: true,
      searching: true,
      info: true,
      lengthChange: false,
      pageLength: 10,
      language: {
        url: '//cdn.datatables.net/plug-ins/1.10.25/i18n/French.json'
      },
      columnDefs: [
        {
          targets: [1, 2, 3],
          className: 'text-center'
        },
        {
          targets: 1,
          type: 'num'
        },
        {
          targets: 2,
          type: 'num'
        }
      ],
      order: [[1, 'desc']] // Order by NPS score descending by default
    });
  }

  /**
   * Initialize DataTable for the field breakdown table
   */
  initFieldBreakdownTable() {
    const table = $('#field-breakdown-table');
    if (table.length === 0) {
      return;
    }

    this.fieldBreakdownDataTable = table.DataTable({
      paging: false,
      ordering: true,
      searching: false,
      info: false,
      lengthChange: false,
      language: {
        url: '//cdn.datatables.net/plug-ins/1.10.25/i18n/French.json'
      },
      columnDefs: [
        {
          targets: [1, 2],
          className: 'text-center'
        },
        {
          targets: 1,
          type: 'num'
        }
      ],
      order: [[1, 'desc']] // Order by average descending by default
    });
  }

  /**
   * Cleanup when leaving the page
   */
  onDestroy() {
    // Destroy DataTable instances to prevent memory leaks
    if (this.entitiesDataTable) {
      this.entitiesDataTable.destroy();
      this.entitiesDataTable = null;
    }
    if (this.fieldBreakdownDataTable) {
      this.fieldBreakdownDataTable.destroy();
      this.fieldBreakdownDataTable = null;
    }
  }
}
